<script setup lang="ts">

import { NavigationItems } from '@components/NavigationItems';

</script>

<template>

    <div class="mt-8">
    
        <div class="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3">
            <div class="col-span-1 px-8">
                <img src="@/assets/images/carbucks.png" class="h-10 mx-auto md:mx-0"/>
            </div>
            <div class="col-span-1 md:col-span-2 px-8 pt-2 text-center md:text-left">
                <div class="grid grid-cols-1 md:grid-cols-2">
                    <div class="flex flex-col gap-2">
                        <h2 class="font-semibold">Pages</h2>
                        <NavigationItems :show-privacy="true" />
                    </div>
                    <div class="mt-8 md:mt-0 flex flex-col">
                        <h2 class="font-semibold">Contact</h2>
                        <a href="mailto:sales@carbucks.com.au">sales@carbucks.com.au</a>
                        <h2 class="font-semibold mt-6">Useful Links</h2>
                        <RouterLink to="/sales" class="text-cyan-500 font-semibold">Presidian &raquo;</RouterLink>
                        <RouterLink to="/carnex" class="text-cyan-500 font-semibold">Carnex &raquo;</RouterLink>
                        <RouterLink to="/onboarding" class="text-cyan-500 font-semibold">Onboarding Presentation &raquo;</RouterLink>
                        <RouterLink to="/products/protect" class="text-cyan-500 font-semibold">PROTECT Explanation &raquo;</RouterLink>
                    </div>
                </div>
            </div>            
        </div>

        <div class="mt-16 border-t border-gray-100 py-8 text-gray-500 flex items-center justify-center">
            Copyright &copy; Carbucks {{ new Date().getFullYear() }}
        </div>

    </div>

</template>